import { render, staticRenderFns } from "./info-screening-history.vue?vue&type=template&id=595a3f3e&scoped=true&"
import script from "./info-screening-history.vue?vue&type=script&lang=js&"
export * from "./info-screening-history.vue?vue&type=script&lang=js&"
import style0 from "./info-screening-history.vue?vue&type=style&index=0&id=595a3f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a3f3e",
  null
  
)

export default component.exports